'use strict';

define('FormOptimizationExperiments', [
  'underscore',
  'telemetry',
   'FormDefUtils'],
function(_, telemetry, formDefUtils){

    // A treatment which alters the "cover cost" checkbox value to default to true
    // linter is disabled because this function "implements" an "interface" and it's OK that we don't use all params
    function coverCostTreatment(formDef, query_string){ // jshint ignore:line
      var coverCostElement = formDefUtils.find_field(formDef.form_elements, 'CoverCostsAmount', false);

      if(coverCostElement){
        coverCostElement.default_value = true;
      }
    }

    // enrollment criteria for Cover Cost experiment
    function isCoverCostEligible(formDef, query_string) {
      // Form not eligible if cover costs query param exists
      if (query_string.hasOwnProperty('covercosts'))
      {
        return false;
      }

      // Form not eligible if cover costs element does not exist or does not have a default value of false
      var coverCostElement = formDefUtils.find_field(formDef.form_elements, 'CoverCostsAmount', false);
      return !!coverCostElement && !coverCostElement.default_value;
    }

    function isGenericExperimentEligible(formDef, query_string){
      // Form not eligible if the experiments section does not exist
      if (!formDef.hasOwnProperty('experiment'))
      {
        return false;
      }

      // Form not eligible if kiosk query param exists (this matches the rest of the codebase)
      if (!!query_string.kiosk)
      {
        return false;
      }

      // Form not eligible if the type of our form is not equal to "ContributionForm"
      if (formDef.type !== 'ContributionForm')
      {
        return false;
      }

      // Form not eligible if the variants section does not exist
      if (!formDef.experiment.hasOwnProperty('variants'))
      {
        return false;
      }

      // Form not eligible if the sum of the probabilities of the variants is not equal to exactly 1
      var sum = 0;
      _.each(formDef.experiment.variants, function(variant){sum += variant.probability;});
      // Handle js floating point issues
      sum = Math.round(sum * 10000) / 10000;
      return sum === 1;
    }

    // An experiment may have multiple variants, including the control variant.
    // This object maps each variant name in the cover cost experiment to its corresponding variant treatment function
    // a variant treatment function is a function which takes a formdef as input, and treats it, returning void
    var coverCostVariants = {
        'Treatment (Default Checked)': coverCostTreatment,
        'Control (Default Unchecked)': function() {return} // control does nothing
    };

    // this dictionary maps an ExperimentName, to another object which maps VariantNames to treatment functions
    var experimentVariants = {
        'Covered Costs Default Setting': coverCostVariants
    };

    // this dictionary maps an ExperimentName to a "enrollment" function which takes FormDef and query parameters as arguments
    // and returns true or false, whether this form and this form load meets enrollment criteria or not
    var experimentEligibilities = {
      'Covered Costs Default Setting': isCoverCostEligible
    };

    // Choose a variant by iterating through the variant array, with a random number between 0.0 and 1.0
    function weightedVariantChoice(variants, randomNumber){
        var accumulator = 0;

        // iterate thru variant array
        for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];

            // accumulate the probability, if we get above the randomNumber,
            // choose this variant, otherwise continue
            accumulator += variant.probability;
            if(accumulator >= randomNumber){
                return variant;
            }
        }
    }

    function getOverrideVariant(variants, overrideVariantName) {
        for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            if(variant.variantName === overrideVariantName){
                return variant;
            }
        }

        // if we got here and didn't choose a variant, that means the overrideVariantName was not a valid variant name. Log the error and return null
        telemetry.trackTrace({
            message: 'FormOptimizationExperiments.getOverrideVariant: Could not choose override variant\n\tOverrideVariantName querystring value: ' + overrideVariantName + '\n\tVariants: {' + variants.join(', ') + '}',
        });
        return null;
    }

    function treatFormDef(formDef, query_string){
      try {
        // check generic and experiment-specific eligibilities and return if this form, or this formload is not eligible to be enrolled in this experiment
        if(!isGenericExperimentEligible(formDef, query_string) || !experimentEligibilities[formDef.experiment.experimentName](formDef, query_string)){
          return;
        }

        var shouldOverrideVariant = !!query_string.overridevariantname;

        // allow QA to override the variant choice process to manually test variant functionality
        // if query params includes `overrideVariantName` param, otherwise choose variant through weighted random choice
        var chosenVariant = shouldOverrideVariant ?
                                getOverrideVariant(formDef.experiment.variants, query_string.overridevariantname) :
                                weightedVariantChoice(formDef.experiment.variants, Math.random());

        // if there was a problem choosing a variant, do nothing and return
        if(!chosenVariant) {
            // we don't actually have an exception here, either this is a malformed experiment or the overridevariantname query string was bad
            telemetry.trackTrace({
                message: 'Error choosing experiment variant\n\tExperiment ID: ' + formDef.experiment.experimentId,
            });
            return;
        }

        telemetry.trackEvent({
            name: 'Experiment Variant Chosen',
            properties: {
                FormId : formDef.formId,
                ChosenVariantName: chosenVariant.name,
                FormVersion: formDef.formVersion,
                VariantChoiceOverride: shouldOverrideVariant
            }
        });

        // get the set of treatment functions for our current experiment
        var variantFunctionsPerExperiment = experimentVariants[formDef.experiment.experimentName];

        // match chosenVariant.variantName to key of treatmentFunctions, call matching function
        variantFunctionsPerExperiment[chosenVariant.variantName](formDef, query_string);

        // assign the chosen variant back to the form def, so we can pass it back to OA later
        // in the tracking pixel and submission
        formDef.experiment.chosenVariantId = chosenVariant.variantId;
      }
      catch(ex){
        telemetry.trackException({exception: ex, properties: {ErrorType: 'Form Optimization Experiment Error'}});
      }
    }

    return {
        treatFormDef: treatFormDef
    };
});

